import { shuffle, range, sampleSize, each } from 'lodash';

const capitalizeFirstLetter = (inputValue) => {
  if (!inputValue) return '';
  if (typeof inputValue !== 'string') return inputValue;
  return inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
};

/**
 * Generates array of random numbers
 * @param size {Number}
 * @param max {Number}
 * @returns {Array}
 */
const generateRandomNumbersArray = (size, max) => {
  const numbersRange = range(1, max + 1);
  const numbersShuffle = shuffle(numbersRange);
  const numbersSample = sampleSize(numbersShuffle, Number(size));

  const betSelection = [];
  const sortedNumSample = numbersSample.sort((a, b) => a - b);
  for (const num of sortedNumSample) {
    betSelection.push(String(num));
  }

  return betSelection;
};

/**
 * Generates array of random numbers for specific color for Lucky X game
 * @param size {Number}
 * @param colorIndex {Number}
 * @returns {Array}
 */
const generateLuckyXRandomColorArray = (size, colorIndex) => {
  const max = 50;

  const filteredRange = Array.from({ length: max }, (_, i) => i + 1).filter((num) => num % 5 === colorIndex % 5);

  const shuffled = shuffle(filteredRange);
  const sampled = sampleSize(shuffled, Number(size));

  return sampled.sort((a, b) => a - b).map(String);
};

/**
 * Get First Ball Color value on rebet
 * @param value {Number}
 * @returns {Object}
 */
const getDisplayValueForFirstBallColorLuckyX = (value) => {
  const inputArray = [];
  let colorIndex = '';
  each([0, 1, 2, 3, 4], (n) => {
    if (parseInt(value, 10) & (2 ** n)) {
      colorIndex = n === 0 ? 5 : n;
      inputArray.push(colorIndex);
    }
    inputArray.sort((a, b) => a - b);
  });
  const inputObject = Object.fromEntries(inputArray.map((value, index) => [index + 1, value]));
  return inputObject;
};

// TODO TEMP FIX UNTIL ALL TRANSLATION KEYS FROM SDK ARE UPDATED
const mapTranslationsForSdk = (translations) => {
  const mappedTranslations = {};
  for (const translation in translations) {
    if (Object.prototype.hasOwnProperty.call(translations, translation)) {
      mappedTranslations[`general_${translation}`] = translations[translation];
    }
  }
  return mappedTranslations;
};

const mapConfigRules = (rules, currency) => {
  const mappedRules = {};
  if (currency && rules[currency]) {
    Object.keys(rules).forEach((key) => {
      mappedRules[key] = rules[currency][key] !== undefined ? { name: key, value: rules[currency][key] } : rules[key];
    });
  } else {
    return rules;
  }
  return mappedRules;
};

const mapConfigTaxes = (rules, currency) => {
  if (!currency || !rules[currency]) return {};
  const mappedTaxes = {
    payin: {},
    payout: {},
  };
  Object.keys(rules[currency]).forEach((key) => {
    if (key === 'payInTax') {
      mappedTaxes.payin = { policy: rules[currency][key] !== undefined ? rules[currency][key] : rules[key] };
    } else if (key === 'payoutTax') {
      mappedTaxes.payout = { policy: rules[currency][key] !== undefined ? rules[currency][key] : rules[key] };
    }
  });
  return mappedTaxes;
};

/**
 * Normalize taxes format for different games
 * - CrashCash: { payin: {}, payout: { policy: "BAPayoutTax" } }
 * - LuckySix: { payin: { policy, value, hideTax, keyname }, payout: {...} }
 */
const normalizeTaxes = (taxes) => {
  const createDefaultTax = () => ({
    policy: false,
    value: false,
    hideTax: true,
    keyname: '',
  });

  const normalizeTax = (tax) => {
    if (!tax || Object.keys(tax).length === 0) {
      return createDefaultTax();
    }

    // CrashCash format: has policy but missing value/hideTax
    if (tax.policy && tax.value === undefined) {
      return {
        policy: tax.policy,
        value: true,
        hideTax: false,
        keyname: tax.keyname || '',
      };
    }

    // LuckySix format: full object
    return {
      policy: tax.policy || false,
      value: tax.value ?? false,
      hideTax: tax.hideTax ?? true,
      keyname: tax.keyname || '',
    };
  };

  if (!taxes) {
    return {
      payin: createDefaultTax(),
      payout: createDefaultTax(),
    };
  }

  return {
    payin: normalizeTax(taxes.payin),
    payout: normalizeTax(taxes.payout),
  };
};

export {
  capitalizeFirstLetter,
  generateRandomNumbersArray,
  generateLuckyXRandomColorArray,
  getDisplayValueForFirstBallColorLuckyX,
  mapTranslationsForSdk,
  mapConfigRules,
  mapConfigTaxes,
  normalizeTaxes,
};
